import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { RingType } from './constants';
import { RingProVariants } from './ringProVariants';
import { ringProFromOpsSkuCode } from './shipByConfig';

export const VARIANT_GID_PREFIX = 'gid://shopify/ProductVariant/';

/** The normal Ring PRO product on the US store (handle ultrahuman-ring-pro),
 * read from the Storefront API on 27 Oct. Pickup lines are reported under it. */
export const RING_PRO_PRODUCT_ID_US = '7660286115936';

/** The pickup catalogue's variant_id (a bare number) as a Shopify gid. */
export const pickupVariantGid = (variantId: string): string =>
  `${VARIANT_GID_PREFIX}${variantId}`;

/** The normal (shipping) US Ring PRO variant gid for an ops SKU such as
 * "PG08", or null when the SKU is not a colour + size. Same variant the buy
 * page adds for a delivery order, so it follows the dev-store swap in
 * ringProVariants. */
export const normalRingProVariantGid = (opsSku: string): string | null => {
  const parsed = ringProFromOpsSkuCode(opsSku);
  if (!parsed) return null;
  return (
    RingProVariants[parsed.color]?.[parsed.size]?.[RingType.NOT_ENGRAVED]
      ?.variantId[ShopifyStore.US] ?? null
  );
};
